(function() {
    'use strict';

    angular
        .module('valueconnectApp')
        .controller('LenderIntegrationDetailController', LenderIntegrationDetailController);

    LenderIntegrationDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'LenderIntegration', 'Lender'];

    function LenderIntegrationDetailController($scope, $rootScope, $stateParams, entity, LenderIntegration, Lender) {
        var vm = this;

        vm.lenderIntegration = entity;

        var unsubscribe = $rootScope.$on('valueconnectApp:lenderIntegrationUpdate', function(event, result) {
            vm.lenderIntegration = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
